import React from 'react';
import { FolderOpen } from 'lucide-react';
import { MenuToggleButton } from '../components/MenuToggleButton';

const FilesPlaceholder: React.FC = () => {
  return (
    <div className="flex flex-col h-full bg-background rounded-panel-mobile lg:rounded-panel overflow-hidden">
      {/* Header */}
      <header className="flex items-center gap-3 px-4 h-14 shrink-0 border-b border-border">
        <MenuToggleButton />
        <FolderOpen className="size-5 text-primary" strokeWidth={2} />
        <h1 className="text-base font-semibold text-foreground">파일관리</h1>
      </header>

      {/* Placeholder Content */}
      <div className="flex-1 flex flex-col items-center justify-center gap-4 text-muted-foreground">
        <div className="size-16 rounded-2xl bg-primary/10 flex items-center justify-center">
          <FolderOpen className="size-8 text-primary" strokeWidth={1.5} />
        </div>
        <div className="text-center">
          <p className="text-lg font-medium text-foreground">파일관리</p>
          <p className="text-sm mt-1">워크스페이스 파일관리 기능을 준비 중입니다</p>
        </div>
      </div>
    </div>
  );
};

export default FilesPlaceholder;
